import React from "react";
import * as apiUtils from "../../../util/apiUtil";
import Loading from "../../../component/loading/Loading";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as inquiryAction from "../store/inquiry";
import InquiryListTable from "../component/InquiryListTable";
import * as dateUtil from "../../../util/dateUtil";
import InquirySearchEngine from "../component/InquirySearchEngine";

class InquiryListContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.handlePageChange = this.handlePageChange.bind(this);
        this.ajaxInquiryList = this.ajaxInquiryList.bind(this);

        this.setValue = this.setValue.bind(this);

        this.state = {
            loading: false,
            orderType: 'DESC',
            searchStartDate: dateUtil.dateTimeToStr(new Date()).slice(0, 8) + '01',
            searchEndDate: dateUtil.dateTimeToStr(new Date()).slice(0, 10),
            searchType: 0,
            inquiryStatus: '',
        }
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.orderType !== nextState.orderType
            || this.state.searchStartDate !== nextState.searchStartDate
            || this.state.searchEndDate !== nextState.searchEndDate
            || this.state.searchType !== nextState.searchType
            || this.state.inquiryStatus !== nextState.inquiryStatus
            || this.props.inquiryList !== nextProps.inquiryList
            || this.props.page !== nextProps.page
            || this.props.total !== nextProps.total
        )
    }//end shouldCompUpdate

    componentDidMount() {
        this.ajaxInquiryList();
    }// end compDidMOunt

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    setValue(key, value) {
        const { inquiryAction, page } = this.props;
        if (page !== 1) {
            inquiryAction.setPage(1);
        }

        // 상태 변경 후 콜백에서 검색 실행
        this.setState({
            [key]: value
        }, () => {
            this.ajaxInquiryList();
        });
    }// end setValue

    async handlePageChange(event, value) {
        const { InquiryAction } = this.props;
        await InquiryAction.setPage(value);

        this.ajaxInquiryList();
    }// end handlePageChange

    ajaxInquiryList() {
        const { orderType, searchStartDate, searchEndDate, inquiryStatus, searchType } = this.state;
        const { page, size, InquiryAction } = this.props;
        apiUtils.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/inquiry/list",
            method: apiUtils.requestMethod.POST,
            data: {
                page: page,
                size: size,
                searchType: searchType,
                orderType: orderType,
                searchStartDate: searchStartDate,
                searchEndDate: searchEndDate,
                status: inquiryStatus,
            },
            success: (result) => {
                InquiryAction.setTotal(result.total);
                InquiryAction.setInquiryList(result.content);
            }
        });
    }// end ajaxInquiryList


    render() {
        const { loading } = this.state;
        const { inquiryList, total, size, page } = this.props;
        const { orderType, searchStartDate, searchEndDate, inquiryStatus, searchType } = this.state;
        const { handlePageChange, setValue } = this;
        return (
            <>
                <Loading loading={loading}/>
                <section className='container-xxl inquiry-list'>
                    <h2 className='fs-4'>나의 문의</h2>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='d-flex justify-content-center'>
                                <InquirySearchEngine
                                    orderType={orderType}
                                    searchStartDate={searchStartDate}
                                    searchEndDate={searchEndDate}
                                    inquiryStatus={inquiryStatus}
                                    searchType={searchType}
                                    setValue={setValue}
                                />
                            </div>
                            <InquiryListTable
                                total={total}
                                page={page}
                                size={size}
                                inquiryList={inquiryList}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </section>

            </>
        )
    }// end render
}// end class

export default connect((state) => ({
        inquiryList: state.inquiry.inquiryList,
        total: state.inquiry.total,
        size: state.inquiry.size,
        page: state.inquiry.page
    }),
    (dispatch) => ({
        InquiryAction: bindActionCreators(inquiryAction, dispatch)
    })
)(InquiryListContainer);